import React, { Component } from 'react'

import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip'
import Utils from './Utils'

class ButtonTooltip extends Component {
    render() {
        const isTouchDevice = Utils.isTouchDevice()
        if (isTouchDevice) {
            return this.props.children
        }

        // Map Bootstrap placement names to base-ui side values
        const placementMap = {
            top: 'top',
            bottom: 'bottom',
            left: 'left',
            right: 'right',
            auto: 'top',
        }
        const side = placementMap[this.props.placement] || 'top'

        return (
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        { this.props.children }
                    </TooltipTrigger>
                    <TooltipContent side={ side }>
                        { this.props.additionalOverlay
                            ? this.props.additionalOverlay
                            : this.props.tooltipMessage }
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        )
    }
}

export default ButtonTooltip
